import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry";

// Initialize Sentry error tracking
initSentry();

// Remove loading spinner after hydration
const rootElement = document.getElementById("root")!;
const initialLoader = rootElement.querySelector('.nexqr-initial-loader');

createRoot(rootElement).render(<App />);

// Clean up loading spinner after React renders
if (initialLoader) {
  setTimeout(() => initialLoader.remove(), 100);
}
